
export const PATH_IMOVEIS = 'imoveis';
export const PATH_AREA = 'area';
export const PATH_PRECOS = 'precos';
export const PATH_AUTOCOMPLETE = 'autocomplete';
export const PATH_LOCAIS = 'locais';
export const PATH_TIPOS = 'tipos';
